var browser, os, WW, WH, DH, ST, baseURL, lazy, minW = 320, resizeTo, lang, doc = 'document,html,body', base = ($('base').length ? $('base').attr('href') : $('html').data('base')), lang = $('html').attr('lang'), d = false, previousTop = 0, opened = 0, bd = $('.backdrop'), lastScrollTop = '', scrolldown = 0, running = false, triggered = 0, cartLayerVisible = false;
browser = getBrowser();
os = getOS();

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};

$(document).ready(function () {
    lang = $('html').attr('lang');
    baseURL = $('base').attr('href');
    $('html').addClass('br_' + browser).addClass('os_' + os);

    resize();
    $(window).resize(function () {
        clearTimeout(resizeTo);
        resizeTo = setTimeout(function () {
            resize();
        }, 400);
    });

    scroll();
    $(window).scroll(function () {
        scroll();
    });

    $('body').on('click', '.back-to-webshop', function () {
        bd.fadeOut(function () {
            $(this).removeClass('transparent');
        });

        cartLayerVisible = false;

        if ($('.cart').hasClass('sys') || $('.cart').hasClass('easy-sys')) {
            $('.cart').removeClass('sys easy-sys');
        }
    });

    /* <a>-ra, ha létezik az ID, akkor odagörget */
    $('body').on('click', 'a', function () {
        var href = $(this).attr('href');

        if (!href) {
            return;
        }

        if (href.indexOf('#') != -1) {
            var id = href.substr(href.indexOf('#'));
            if ($(id).length) {
                $(doc).animate({'scrollTop': $(id).offset().top - $('.navbar').height() - 30}, 'slow');
                return false;
            }
        }

    });

    /* Oldalbetöltéskor, ha létezik az ID, akkor odagörget */
    if (window.location.href.indexOf('#') != -1) {
        var id = window.location.href.substr(window.location.href.indexOf('#'));
        if ($(id).length) {

            $('.navbar-right li').removeClass('active');

            $('.navbar-right li').find('a').each(function (i, v) {
                var elem = $(v).attr('href').substr($(v).attr('href').indexOf(id));
                if (id == elem) {
                    $(v).parent().addClass('active');
                }
            });

            $(doc).animate({'scrollTop': $(id).offset().top - $('.navbar').height() - 30}, 'slow');
        }
    }

    menu();
    cartLayer();
    basketSum();
    popup();
    notification();
    backdrop();
    forms();

    if ($('.slider-recomm').length) {
        sliderRecomm();
    }

    if ($('.slider-categories').length) {
        sliderCategories();
    }

    if ($('.slider-products').length) {
        sliderProducts();
    }

    if ($('.slider-series').length) {
        sliderSeries();
    }

    if ($('.slider-iconcategories').length) {
        slideIconCategories();
    }

    if ($('.product-list').length) {
        prodListPage();
    }

    if ($('.product-page').length) {
        productPage();
    }

    if ($('.pp-data').length) {
        collapsableBox();
    }

    if ($('.ss-items').length) {
        sliderSeriesPageV2();
    }

    /* 2024 */
    if ($('.slider__recommendation').length) {
        sliderRecommendation();
    }

    if ($('.tiles').length) {
        countTiles();
    }


    setTimeout(function () {
        $('html').addClass('page-loaded');
        if(!$('.popup').hasClass('active')) {
            $('document').trigger('click');
        }
    }, 500);
});

var cat = $('.navbar').height() * 2;

function scroll() {
    WW = $(window).width();
    ST = $(window).scrollTop();

    /* create scroll functions */
    if (ST < previousTop) {
        //ha fel görgetek
        if (ST <= cat) {
            $('html').removeClass('scrolled-down');
        }

        if (($(window).height() * 0.2) > ST) {
            $('html').removeClass('scrolled-down');
        }

        if (($(window).height() * 0.3) > ST) {
            $('html').removeClass('sys');
            $('.navbar-top-row .navbar-left').remove();
        }

        if (ST > 0) {
            //ha nem a tetején vagyok

        } else {
            //ha a tetjére ért
        }
    } else {
        if (ST > ($(window).height() * 0.2)) {
            $('html').addClass('scrolled-down');

            if (WW >= 992) {
                if (!$('.navbar-top-row .navbar-left').length) {
                    $('.navbar-left').clone().appendTo('.navbar-top .row');
                    $('.header .submenu').removeClass('sys');
                }
            } else {
                if ($('html').hasClass('menu-open')) {
                    $('.navbar .container .row').css('top', $('.header').outerHeight());
                }
            }
        }

        if (ST > ($(window).height() * 0.3)) {
            $('html').addClass('sys');
        }

        if (ST > 0) {
            // LE: ha nem a tetején vagyunk
            if ($('.search').hasClass('sys')) {
                bd.trigger('click');

            }
        }

        if (ST > previousTop && ST > cat && !d) {
            //ha le görgetek

            lastScrollTop = ST;

            if (scrolldown == 0) {
                setTimeout(function () {
                    $(window).scrollTop($(window).scrollTop() + 1);
                    scrolldown = 1;
                }, 100);
            }
        }
    }

    previousTop = ST;
}

function resize() {
    WW = $(window).width();
    WH = $(window).height();
    DH = $(document).height();

    /* create resize functions */
    resizeBoxes('.product-list', '.product-title');
    resizeBoxes('.myprofile-favs', '.product-title');

    resizeBoxes('.row-product', '.product-title');


    $('main').css({
        'margin-top': parseInt($('.header').outerHeight()) * 1
    });

    if (WW <= 991) {
        if ($('.slider-so').length && !$('.slider-so').hasClass('slick-initialized')) {
            sliderSeriesProducts();
        }
    } else {
        if ($('.slider-so').length && $('.slider-so').hasClass('slick-initialized')) {
            $('.slider-so').slick('unslick');
        }
    }

    if (WW <= 769) {
        if ($('.ss-items').length) {
            $('.ss-item-onlytext').parent('.col-4').hide();
            $('.ss-item-onlytext').parent('.col-12').show();
        }
    } else {
        if ($('.ss-items').length) {
            $('.ss-item-onlytext').parent('.col-4').show();
            $('.ss-item-onlytext').parent('.col-12').hide();
        }
    }

    if (WW <= 575) {
        resizeBoxes('.row-product', '.product-price');
    } else {

    }

}

